import { render, staticRenderFns } from "./RegisterDocumentsInfoPane.vue?vue&type=template&id=44a05b4c&scoped=true&"
import script from "./RegisterDocumentsInfoPane.vue?vue&type=script&lang=js&"
export * from "./RegisterDocumentsInfoPane.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDocumentsInfoPane.vue?vue&type=style&index=0&id=44a05b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a05b4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VIcon,VRow})
